//기프티콘 캐쉬 관리표 공용 상수/포맷

export const C = {
    blue: "#2F6FED",
    blueBg: "#F2F6FF",
    blueIconBg: "#E4ECFF",
    red: "#C8102E",
    redBg: "#FFF1F1",
    gray: "#6B7280",
    grayBg: "#F7F8FA",
    text: "#1F2328",
    border: "#D9DEE4",
    line: "#E3E6EA",
    rowLine: "#F0F2F4",
};

export const toastOptions: any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored",
};

export const formatComma = (num: number) => {
    return Math.abs(Math.round(num)).toLocaleString("ko-KR");
};

//-4,500 / 41,000 (부호 포함)
export const formatSigned = (num: number) => {
    if (num < 0) return `-${formatComma(num)}`;
    return formatComma(num);
};

//잔액 색: 음수 빨강 볼드 / 0 회색 / 양수 검정
export const balanceStyle = (balance: number): React.CSSProperties => {
    if (balance < 0) return { color: C.red, fontWeight: 700 };
    if (balance === 0) return { color: C.gray };
    return { color: C.text };
};

export const typeLabels: { [key: string]: string } = {
    charge: "충전",
    review: "지도리뷰",
    exitSurvey: "퇴원생설문",
};

export const formatMonthDayTime = (v: any) => {
    if (!v) return "";
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    return `${d.getMonth() + 1}/${d.getDate()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const formatFullDateTime = (v: any) => {
    if (!v) return "";
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    const p = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const thisMonth = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const chipStyle = (active: boolean): React.CSSProperties => ({
    height: 30,
    padding: "0 12px",
    border: `1px solid ${active ? C.blue : C.border}`,
    background: active ? C.blueBg : "#FFFFFF",
    borderRadius: 999,
    fontSize: 12,
    fontFamily: "inherit",
    color: active ? C.blue : C.text,
    fontWeight: active ? 500 : 400,
    cursor: "pointer",
});

//캐쉬 지점 9개 (서버 control/giftCash.ts GIFT_CASH_BRANCHES 와 순서·키 동일)
export const GIFT_CASH_BRANCHES = [
    { key: "hq", label: "본사직영", sub: "강남·송파·대치" },
    { key: "bundang", label: "분당" },
    { key: "daegu", label: "대구" },
    { key: "gangdong", label: "강동" },
    { key: "gimpo", label: "김포" },
    { key: "dongtan", label: "동탄" },
    { key: "hanam", label: "하남" },
    { key: "centum", label: "센텀" },
    { key: "sinchon", label: "신촌" },
];

export const giftCashBranchLabel = (key: string) => {
    const branch = GIFT_CASH_BRANCHES.find((b) => b.key === key);
    return branch ? branch.label : key;
};
